
import React, { useState } from "react";
import { apiUrl } from "../../config";
import { FullDetails } from "../../design-system/components/FullDetails";

/**
 * FACEIT Data API: Match Stats
 * This page calls your backend wrapper for GET /matches/{match_id}/stats.
 * What you get without fetching: detailed stats for a match (per-team and per-player),
 * including K/D and per-map/round info when provided by FACEIT.
 */
export function MatchStats() {
  const [id, setId] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);

  async function fetchStats() {
    setErr(null);
    setData(null);
    if (!id) return;
    setLoading(true);
    try {
      const res = await fetch(apiUrl(`/api/faceit/matches/${encodeURIComponent(id)}/stats`));
      const json = await res.json();
      if (!res.ok || json?.error) setErr(json?.error || `HTTP ${res.status}`);
      else setData(json);
    } catch (e: any) {
      setErr(e?.message || "Network error");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="space-y-4">
      {/* Header */}
      <div>
        <h2 className="text-2xl font-bold">FACEIT Match Stats</h2>
        <p className="text-sm text-muted">
          Returns detailed statistics for a specific match (team/player stats and map/round info when available).
        </p>
      </div>

      {/* Form */}
      <div className="bg-surface border border-border rounded-lg p-4 space-y-3">
        <div className="flex items-center gap-2">
          <input
            value={id}
            onChange={(e) => setId(e.target.value)}
            placeholder="FACEIT match_id"
            className="flex-1 bg-bg border border-border rounded-md px-3 py-2 text-sm focus:outline-none focus:border-[#4FC3F7]"
          />
          <button
            type="button"
            onClick={fetchStats}
            disabled={!id || loading}
            className="px-3 py-2 rounded-md border border-border hover:border-[#4FC3F7] hover:text-[#4FC3F7] transition text-sm"
          >
            {loading ? "Loading…" : "Fetch"}
          </button>
        </div>

        {err && <pre className="text-xs text-red-400 overflow-x-auto">{err}</pre>}
      </div>

      {/* Result */}
      {data && (
        <FullDetails data={data} title="All fields" open />
      )}
    </div>
  );
}
